/**
 * 角色信息
 */
 import React from 'react';
 import { Input, Button,DatePicker, Row, Col, Icon, Tooltip } from 'antd';
 import PageLayout from '../../ui/PageLayout';
 import http from '../../../axios/http';
 import messager from '../../ui/messager';
 
 
 class TaxBillIndex extends React.Component {
     columns = [{
         title: '日期',
         dataIndex: 'date',
         width: '20%',
     }, {
        title: '税票号码',
        dataIndex: 'bill_no',
        width: '20%',
    }, {
        title: '纳税人识别号',
        dataIndex: 'company_no',
        width: '20%',
    }, {
        title: '公司名',
        dataIndex: 'company_name',
        width: '20%',
    },{
        title: '税种',
        dataIndex: 'tax_name',
        width: '20%',
    },{
        title: '品目名称',
        dataIndex: 'type_name',
        width: '20%',
    },{
        title: '课税数量',
        dataIndex: 'tax_num',
        width: '20%',
    },{
        title: '计税金额',
        dataIndex: 'tax_amount',
        width: '20%',
    },{
        title: '税率',
        dataIndex: 'tax_percent',
        width: '20%',
    },{
        title: '所属时期',
        dataIndex: 'tax_date',
        width: '20%',
    },{
        title: '实缴金额',
        dataIndex: 'tax_real',
        width: '20%',
    },{
        title: '录入人',
        dataIndex: 'creator',
        width: '20%',
    },{
        title: '时间',
        dataIndex: 'insert_time',
        width: '20%',
    },{
         title: '操作',
         dataIndex: 'id',
         width: '10%',
         render: (text, record, index) => (
             <div>
                 <Tooltip title="删除">
                     <Icon type="delete" theme="filled" title="删除" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                 </Tooltip>
             </div>
         ),
     }];
 
     state = {
         visible: false,
         queryData: {},
         loadData: ''
     };

     inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }
     rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }
 
    delete = (info, e) => {
        messager.confirm("是否删除该票据记录？", () => {
            http.post({
                url: '/taxBill/deleteById',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/taxBill/download',
            data: queryData,
            fileName: "税收缴款书.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

 
     showModal = () => {
         this.setState({ visible: true });
     };
     hiddenModal = () => {
         this.setState({ visible: false });
     };
 
     render() {
         return (
             <div style={{ width: '100%', height: '100%' }}>
                 <PageLayout
                     condition={(
                         <Row>
                             <Col span={20}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ width: 250, marginRight: '10px' }}/>   
                                <Input.Search
                                    placeholder="用户名"
                                    onSearch={this.inputSearch.bind(this, "creator")}
                                    // {value => this.state.loadData({ creator: value })}
                                    enterButton
                                    style={{ width: 250, marginRight: '10px' }}
                                />
                                <Input.Search
                                    placeholder="税票号码"
                                    onSearch={this.inputSearch.bind(this, "bill_no")}
                                    // {value => this.state.loadData({ bill_no: value })}
                                    enterButton
                                    style={{ width: 250, marginRight: '10px' }}
                                />
                                <Input.Search
                                    placeholder="纳税人识别号"
                                    onSearch={this.inputSearch.bind(this, "company_no")}
                                    // {value => this.state.loadData({ company_no: value })}
                                    enterButton
                                    style={{ width: 250, marginRight: '10px' }}
                                />
                             </Col>
                             <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                             
                             {/* <Col span={16} style={{ textAlign: "right" }}>
                                 <Button type="primary" onClick={this.add}>新增</Button>
                             </Col> */}
                         </Row>
                     )}
                     rowKey="id"
                     url="/taxBill/findTaxBillsByPage"
                     columns={this.columns}
 
                     loadData={(func) => { this.setState({ loadData: func }) }}
                 />
                 {/* <RoleEdit
                     visible={this.state.visible}
                     onCancel={this.hiddenModal.bind(this)}
                     editData={this.state.editData}
                     successCallback={this.state.loadData}
                 /> */}
             </div>
         )
     }
 
 }
 
 export default TaxBillIndex;